import { createSlice } from "@reduxjs/toolkit";
import { IAdminSettingState } from "./adminsettingModel";
import {
  getAdminSettings,
  updateAdminSettings,
} from "./services/adminsetting.services";

const initialState: IAdminSettingState = {
  loading: false,
  error: "",
  AdminSettingDetails: {
    GST: null,
    TCSOverPer: null,
    TCSUnderPer: null,
    TCSLimit: null,
    Dom_Quot_TermsNCondition: "",
    Int_Quot_TermsNCondition: "",
    Dom_FIT_TermsNCondition: "",
    Int_FIT_TermsNCondition: "",
    FlightTermsAndCondition: "",
    HotelTermsAndCondition: "",
    VisaTermsAndCondition: "",
  },
};

const adminsettingSlice = createSlice({
  name: "adminsetting",
  initialState,
  reducers: {
    clearAdminSettingDetails: (state) => {
      state.AdminSettingDetails = initialState.AdminSettingDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateAdminSettings.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateAdminSettings.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(updateAdminSettings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAdminSettings.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAdminSettings.fulfilled, (state, action: any) => {
      state.loading = false;
      state.AdminSettingDetails = action.payload;
    });
    builder.addCase(getAdminSettings.rejected, (state, action) => {
      state.loading = false;
      state.AdminSettingDetails = initialState.AdminSettingDetails;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const { clearAdminSettingDetails } = adminsettingSlice.actions;
export default adminsettingSlice.reducer;
